module.exports = __webpack_public_path__ + "img/food_pizza.d338e4e4.png";